export default "__VITE_ASSET__e208d625__"